import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from './_services/permission.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguagesStaticText } from './_services/language.servic';

// import { NgxPermissionsService } from 'ngx-permissions';


@Component({
  selector: 'datalive-app',
  template: `<header-app></header-app>
  <router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {

constructor(private permissions: PermissionService, 
  private translate: TranslateService,
  private languagesStaticText: LanguagesStaticText
  ) { 
    let selectedLanguage = localStorage.getItem('SelectedLanguage')
    console.log(selectedLanguage)
    if(selectedLanguage) {
      this.languagesStaticText.handleChangeLanguage(selectedLanguage);
    } else{
      localStorage.setItem('SelectedLanguage', "EN");
      this.languagesStaticText.handleChangeLanguage("EN");
    }
    

    // this.languagesStaticText.getLanguages('assets/i18n/pt.json').subscribe((language: any) => {
    //   this.translate.setTranslation("pt", JSON.parse(language._body));
    //     this.translate.setDefaultLang("pt");
    // })
  }
  
 
  ngOnInit() {

      // SET Permissions -  set the local storage user info object --
      let _currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (_currentUser) {
      // logged in so return true
        this.permissions.setPermissionsAndRoles(_currentUser.user);
       
        //this.setPermissions(_currentUser);
       
      } else {
        
      }
      
     
  }

  // public setPermissions(_user):void {
  //    let _perms = _user.user.modules;
  //     var _modulePermList = _perms.map(function(obj) { 
  //       let _permissions = obj.name;
  //       return _permissions.toUpperCase();
  //     });
  //     console.log('permissions array: ', _modulePermList);
  //     //Pass a permissions array into service e.g. ['Timesheet', 'seeMeeting', 'editMeeting', 'deleteMeeting'];
  //     this.permissionsService.loadPermissions(_modulePermList);
    
  //     // DEBUG Get permissions store
  //     this.permissionsService.permissions$.subscribe((permissions) => {
  //         console.log('App permissions: ', permissions)
  //     });
  // }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/app.component.ts